export const BUSINESS_EMAIL_TEMPLATES_FIELDS = {
  NAME: {
    field: "ten",
    type: "text",
    disabled: false,
    required: true,
    translate: 'name',
  },
  EMAIL_TYPE: {
    field: "loai_email",
    type: "select",
    disabled: false,
    required: true,
    translate: 'email_type',
  },
  TITLE: {
    field: "tieu_de",
    type: "text",
    disabled: false,
    required: true,
    translate: 'title',
  },
  CONTENT: {
    field: "noi_dung",
    type: "text",
    disabled: false,
    required: true,
    translate: 'content',
  },
  VALID: {
    field: "hieu_luc",
    type: "date",
    disabled: false,
    required: false,
    translate: 'valid',
  },
  START_DATE: {
    field: "ngay_bat_dau",
    type: "date",
    disabled: false,
    required: false,
    translate: 'start_date',
  },
  END_DATE: {
    field: "ngay_ket_thuc",
    type: "date",
    disabled: false,
    required: false,
    translate: 'end_date',
  }
};
